import cn from 'classnames'
import {useToastStore} from '../../state/toast.js'
import styles from './toast.module.scss'

/**
 * Host component that subscribes to the toast store and renders the stack.
 * Mount once near the app root.
 */
export function ToastHost() {
    const toasts = useToastStore(state => state.toasts)
    const dismissToast = useToastStore(state => state.dismissToast)

    if (toasts.length === 0)
        return null

    return (
        <div className={styles.host} aria-live="polite">
            {toasts.map(t => (
                <Toast key={t.id} toast={t} onDismiss={() => dismissToast(t.id)}/>
            ))}
        </div>
    )
}

/**
 * @param {{
 *   toast: import('../../state/toast.js').Toast,
 *   onDismiss: () => void
 * }} props
 */
export function Toast({toast, onDismiss}) {
    const isAlert = toast.variant === 'alert'
    const isUpdate = toast.variant === 'update'
    return (
        <div
            className={cn(styles.toast, styles[toast.variant])}
            role={isAlert ? 'alert' : 'status'}
            aria-atomic="true"
        >
            <div className={styles.copy}>
                <div className={styles.title}>{toast.title}</div>
                {!!toast.body && <div className={styles.body}>{toast.body}</div>}
            </div>
            {!!toast.action && (
                <button
                    type="button"
                    className={styles.action}
                    onClick={() => {
                        toast.action.onClick()
                        onDismiss()
                    }}
                >
                    {toast.action.label}
                </button>
            )}
            {!isUpdate && (
                <button
                    type="button"
                    className={styles.dismiss}
                    aria-label="Dismiss notification"
                    onClick={onDismiss}
                >
                    ×
                </button>
            )}
        </div>
    )
}
